module.exports = __webpack_public_path__ + "img/1514967571.d02c315c.jpg";